// Posición de los videos guardada en el navegador del alumno (ver TrackedVimeo).
// Clave: `${VIDEO_POSITION_KEY}:${userId}:${classId}:${videoId}`.
export const VIDEO_POSITION_KEY = 'video-position';

export interface SavedVideoPosition {
  seconds: number;
  duration: number;
  savedAt?: number;
}

export interface LastVideoPosition extends SavedVideoPosition {
  classId: string;
  videoId: string;
}

/** La última clase con posición guardada por este usuario (la más reciente por savedAt). */
export const getLastVideoPosition = (userId: string): LastVideoPosition | null => {
  const prefix = `${VIDEO_POSITION_KEY}:${userId}:`;
  let latest: LastVideoPosition | null = null;
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith(prefix)) {
        continue;
      }
      const [classId, videoId] = key.slice(prefix.length).split(':');
      const parsed = JSON.parse(localStorage.getItem(key) || 'null') as SavedVideoPosition | null;
      if (!parsed || typeof parsed.seconds !== 'number') {
        continue;
      }
      if (!latest || (parsed.savedAt ?? 0) > (latest.savedAt ?? 0)) {
        latest = { ...parsed, classId, videoId };
      }
    }
  } catch {
    return null;
  }
  return latest;
};
